var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82922 9.516C4.82922 11.7083 5.7001 13.8108 7.25028 15.3609C8.80045 16.9111 10.9029 17.782 13.0952 17.782C15.2875 17.782 17.39 16.9111 18.9402 15.3609C20.4903 13.8108 21.3612 11.7083 21.3612 9.516C21.3612 7.32372 20.4903 5.22123 18.9402 3.67105C17.39 2.12088 15.2875 1.25 13.0952 1.25C10.9029 1.25 8.80045 2.12088 7.25028 3.67105C5.7001 5.22123 4.82922 7.32372 4.82922 9.516Z",
    stroke: "#03212B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0952 17.7824L17.7792 25.8969L19.9807 21.4429L24.9376 21.7625L20.2535 13.6494M5.93406 13.6494L1.25 21.7639L6.20684 21.4429L8.40835 25.8955L13.0924 17.7824",
    stroke: "#03212B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq5);
export default __webpack_public_path__ + "static/media/faq5.48b134cc06b474ff72eea8c2794b5c84.svg";
export { ForwardRef as ReactComponent };